import { FulfillmentCompany } from "../modules";

export const FulfillmentCompanyPage = () => {
  return <FulfillmentCompany />;
};
